// extracted by mini-css-extract-plugin
export default {"mono":"address_mono__Ms+Ud","input":"address_input__9dhOD","nameinput":"address_nameinput__R-ftd","cityinput":"address_cityinput__vI5Fv","button":"address_button__qBtfX"};